import React from "react"
import Nav from '../components/Nav';
import '../utils/style.scss';

const Layout = ({ location, title, children }) => {
  // const rootPath = `${__PATH_PREFIX__}/`

  return (
    <div className="container">
      <Nav></Nav>
      <main>{children}</main>
      <footer>
        © {new Date().getFullYear()}, Built by
        {` `}
        <a target="_blank" rel="noreferrer" href="https://nich-o-las.github.io">Nick Cox</a>
      </footer>
    </div>
  )
}

export default Layout
